import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayRemainderEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/remainder/`
        this.webApi = new WebApi()
    }

    async getInit () {
        const responses = await this.webApi.get(`${this.url}get`)
        // console.log('responses:', responses)
        if (responses) {
            if (!responses.status_code) {
                if (!responses.error) {
                    return responses
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${responses.status_code}`)
            }
        }
        return null
    }

    async getReport (arg) {
        const responses = await this.webApi.post(`${this.url}report`, arg)
        // console.log('responses:', responses)
        if (responses) {
            if (!responses.status_code) {
                if (!responses.error) {
                    return responses
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${responses.status_code}`)
            }
        }
        return null
    }
}
